import { render, staticRenderFns } from "./EmployerService.vue?vue&type=template&id=6ec7b63e&scoped=true&"
import script from "./EmployerService.vue?vue&type=script&lang=js&"
export * from "./EmployerService.vue?vue&type=script&lang=js&"
import style0 from "./EmployerService.vue?vue&type=style&index=0&id=6ec7b63e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec7b63e",
  null
  
)

export default component.exports